module.exports = __webpack_public_path__ + "static/gatsby-icon-407a8e7feb93f9e3dcd0fe50d36b7d59.png";